import Image from "next/image";
import moment from "moment";
import { useEffect, useState } from "react";
import calculateDiscount from '../../Discounts/discount';

const BookingDetails = ({
  getDetails,
  price,
  originalPrice,
  extraCharge,
  checkOut,
  checkIn,
  checkInTime,
  checkOutTime,
  adult,
  child,
  currency,
  room,
  nights,
  dayCount,
  cityName,
  packageImage,
  packageName,
  vat,
  rating,
  reviews
}) => {
  const [totalPay, setTotalPay] = useState(price);
  const [discountAmount, setDiscountAmount] = useState("-");

  // useEffect(() => {
  //   if (getDetails?.discountAmount) {
  //     setTotalPay(getDetails?.discountAmount);
  //     setDiscountAmount(getDetails?.discountAmount);
  //   } else if (price && !getDetails?.discountAmount) {
  //     setTotalPay(price);
  //   }
  // }, [getDetails, price]);

  useEffect(() => {
    const { discountAmount, totalPay } = calculateDiscount(price, getDetails);
    setDiscountAmount(discountAmount);
    setTotalPay(totalPay);
  }, [getDetails, price]);


  return (
    <div className="px-20 py-20 border-light rounded-4">
      <div className="text-20 fw-500 mb-10">Your booking details</div>
      <div className="row x-gap-15 y-gap-20">
        <div className="col-auto">
          <img
            width={140}
            height={140}
            src={`${process.env.IMAGE_BASE_URL}/${packageImage}`}
            alt="image"
            className="size-140 rounded-4 object-cover"
          />
        </div>
        {/* End .col */}
        <div className="col">
          <div className="d-flex x-gap-5 pb-10">
            <i className="icon-star text-yellow-1 text-10" />
            <i className="icon-star text-yellow-1 text-10" />
            <i className="icon-star text-yellow-1 text-10" />
            <i className="icon-star text-yellow-1 text-10" />
            <i className="icon-star text-yellow-1 text-10" />
          </div>
          {/* End ratings */}
          <div className="lh-17 fw-500">{packageName}</div>
          <div className="text-14 lh-15 mt-5">{cityName}</div>
          <div className="row x-gap-10 y-gap-10 items-center pt-10">
            <div className="col-auto">
              <div className="d-flex items-center">
                <div className="size-30 flex-center bg-blue-1 rounded-4">
                  <div className="text-12 fw-600 text-white">
                    {rating !== undefined && rating !== null && rating !== '' && (
                      <div className="text-12 fw-600 text-white">{rating}</div>
                    )}
                  </div>
                </div>
                <div className="text-14 fw-500 ml-10">Exceptional</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="text-14">
                {reviews !== undefined && reviews != null && reviews !== '' && (
                  <div className="text-14">{reviews} reviews</div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* End .col */}
      </div>
      {/* End .row */}

      <div className="border-top-light mt-15" />
      <div className="row y-gap-20 justify-between py-10">
        <div className="col-auto">
          <div className="text-15">Check-in</div>
          <div className="fw-500">
            {moment(checkIn).format("ddd DD MMM YYYY")}
          </div>
          <div className="text-15 text-light-1">{checkInTime}</div>
        </div>
        <div className="col-auto md:d-none row-custom-staycation">
          <div className="h-full w-1 bg-border" />
        </div>
        <div className="col-auto text-right md:text-left">
          <div className="text-15">Check-out</div>
          <div className="fw-500">
            {moment(checkOut).format("ddd DD MMM YYYY")}
          </div>
          <div className="text-15 text-light-1">{checkOutTime}</div>
        </div>
      </div>
      {/* End row */}

      <div className="border-top-light mb-15" />
      <div className="d-flex gap-10">
        <div className="text-15">Total days of stay:</div>
        <div className="fw-500">{nights}{dayCount}</div>
      </div>

      {/* SPLIT AMOUNT */}
      <div className="border-top-light mt-15 mb-10" />
      <div className="row justify-between">
        <div className="col-auto">
          {originalPrice !== 0 && originalPrice !== price && (
            <div className='text-15'>Actual Price</div>
          )}
          {(Number(originalPrice) !== Number(price)) ? <div className="text-15">Discounted Price</div> : <div className="text-15">Actual Price</div>}
          {Number(discountAmount) !== 0 && <div className="text-15">Promotion Discount</div>}
          {Number(discountAmount) !== 0 && <div className="text-15">Sub Total</div>}
          {Number(extraCharge) !== 0 && <div className="text-15">Extra Price</div>}
          {/* {Number(vat) !== 0 && <div className="text-15">VAT(5%)</div>}
          <div className="text-15">To Pay</div> */}
        </div>

        <div className="col-auto text-right md:text-left">
          {Number(originalPrice) !== 0 && (Number(originalPrice) !== Number(price)) && (
            <div className="fw-500">{currency?.toUpperCase()} {Number(originalPrice)}</div>
          )}
          {price !== 0 && (
            <div className="fw-500">{currency?.toUpperCase()} {price}</div>
          )}
          {Number(discountAmount) !== 0 && (
            <div className="fw-500 text-success">
              - {discountAmount !== "-" ? `${currency?.toUpperCase()} ${discountAmount}` : ""}
            </div> // 400
          )}
          {Number(discountAmount) !== 0 && (
            <div className="fw-500">
              {discountAmount !== "-" ? `${currency?.toUpperCase()} ${Number(totalPay)}` : ""}
            </div> // 400
          )}
          {Number(extraCharge) !== 0 && <div className="fw-500">{currency?.toUpperCase()} {Number(extraCharge)}</div>}
          {/* {Number(vat) !== 0 &&
            <div className="fw-500">
              {currency?.toUpperCase()} {vat == 0 ? "-" : `${((Number(totalPay) + Number(extraCharge)) * vat / 100)}`}
            </div>} */}
          {/* <div className="fw-500">
            {currency?.toUpperCase()} {Number(totalPay) + Number(extraCharge) + ((Number(totalPay) + Number(extraCharge)) * vat / 100)}
          </div> */}
        </div>
      </div>
      <div className='border-top-light mt-10 mb-10' />
      <div className="row justify-between">
        <div className="col-auto">
          {Number(vat) !== 0 && <div className="text-15">VAT(5%)</div>}
          <div className="text-15">To Pay</div>
        </div>

        <div className="col-auto text-right md:text-left">
          {Number(vat) !== 0 &&
            <div className="fw-500">
              {currency?.toUpperCase()} {vat == 0 ? "-" : `${((Number(totalPay) + Number(extraCharge)) * vat / 100)}`}
            </div>}
          <div className="fw-500">
            {currency?.toUpperCase()} {Number(totalPay) + Number(extraCharge) + ((Number(totalPay) + Number(extraCharge)) * vat / 100)}
          </div>
        </div>
      </div>
    </div>
    // End px-30
  );
};

export default BookingDetails;
